export const REDUCER_NAME = "inbox";

export const ACTION_TYPES = {
  setInboxTabType: `${REDUCER_NAME}/setInboxTabType`,
  setArInboxTabType: `${REDUCER_NAME}/setArInboxTabType`,
};
